module.exports = __webpack_public_path__ + "img/logo.376ee6ec.png";